/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

// 验证手机号
export function isPhoneNumber(phone) {
    return /^1\d{10}$/.test(phone)
}

//  验证身份证
export function isIDCard(card) {
    let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
    // 校验身份证：
    if (_IDRe18.test(card) || _IDre15.test(card)) {
        return true
    } else {
        return false
    }
    // return /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(card);
}

//手机号转 ****
export function replacePhone(tel) {
    return tel.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
}

// 防抖函数

export function debounce(func, wait) {
    let lastTime = null
    let timeout
    return function () {
        let context = this
        let now = new Date()
        // 判定不是一次抖动
        if (now - lastTime - wait > 0) {
            setTimeout(() => {
                func.apply(context, arguments)
            }, wait)
        } else {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            timeout = setTimeout(() => {
                func.apply(context, arguments)
            }, wait)
        }
        // 注意这里lastTime是上次的触发时间
        lastTime = now
    }
}
 
export function throttle (func, wait) {
    let lastTime = null
    let timeout
    return function () {
     let context = this
     let now = new Date()
     // 如果上次执行的时间和这次触发的时间大于一个执行周期，则执行
     if (now - lastTime - wait > 0) {
      // 如果之前有了定时任务则清除
      if (timeout) {
       clearTimeout(timeout)
       timeout = null
      }
      func.apply(context, arguments)
      lastTime = now
     } else if (!timeout) {
      timeout = setTimeout(() => {
       // 改变执行上下文环境
       func.apply(context, arguments)
      }, wait)
     }
    }
   }